import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { MediaDelete, MediaGet } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import Modal from "react-bootstrap/Modal";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import "./PhotoGallery.css";

const PhotoGallery = () => {
  const location = useLocation();
  const [Photodata, setPhotodata] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [photoToDelete, setPhotoToDelete] = useState(null);
  const myCompanyId = Cookies.get("company_id");
  const UserID = Cookies.get("userID");
  const galleryCompanyId =
    location.state?.company_id != null && location.state?.company_id !== ""
      ? String(location.state.company_id)
      : String(myCompanyId || "");
  const { media, loading } = useSelector((state) => state.GallerySlice);

  const dispatch = useDispatch();

  useEffect(() => {
    if (galleryCompanyId) {
      dispatch(MediaGet({ company_id: galleryCompanyId }));
    }
  }, [dispatch, galleryCompanyId]);

  useEffect(() => {
    if (media?.result?.length > 0) {
      const photoItems = media.result.filter(
        (item) => item.extension_type === "image"
      );
      setPhotodata(photoItems);
    } else {
      setPhotodata([]);
    }
  }, [media]);

  const handleImageClick = (photo) => {
    setSelectedPhoto(photo);
  };

  const handleClose = () => {
    setSelectedPhoto(null);
  };

  const handleDelete = async (id) => {
    const updatedPhotos = Photodata.filter((photo) => photo.id !== id);
    setPhotodata(updatedPhotos);
    await dispatch(MediaDelete({ id }));
  };

  return (
    <>
      {loading && <Lodderr />}
      <motion.div
        className="pg-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="pg-hero">
          <div>
            <h1 className="pg-title">Photos</h1>
            <p className="pg-sub">A premium photo gallery with clean previews and actions.</p>
          </div>
          <span className="pg-pill">
            <i className="bx bx-image"></i> {Photodata.length} photos
          </span>
        </div>

        {Photodata.length > 0 ? (
          <div className="pg-grid">
            {Photodata.map((photo, idx) => {
              const canDelete =
                Number(UserID) === Number(photo?.member_id) &&
                Number(myCompanyId) === Number(photo?.company_id);
              return (
                <motion.div
                  key={photo.id || idx}
                  className="pg-card"
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.2 }}
                  onClick={() => handleImageClick(photo)}
                >
                  {canDelete && (
                    <button
                      className="pg-del"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPhotoToDelete(photo.id);
                      }}
                      aria-label="Delete photo"
                      type="button"
                    >
                      <i className="bx bx-trash"></i>
                    </button>
                  )}

                  <img
                    src={(photo.file_url || "").replace("/thumb", "")}
                    alt={photo.tittle}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.style.display = "none";
                    }}
                  />
                  <div className="pg-cap">
                    <span className="pg-name">{photo.tittle || "Photo"}</span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        ) : (
          <div className="pg-empty">
            <i className="bx bx-image"></i>
            <p>No photos available.</p>
          </div>
        )}
      </motion.div>

      <Modal show={!!selectedPhoto} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedPhoto?.tittle || "Photo"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={(selectedPhoto?.file_url || "").replace("/thumb", "")}
            alt={selectedPhoto?.tittle}
            className="img-fluid rounded w-100"
          />
        </Modal.Body>
      </Modal>

      <ConfirmModal
        isOpen={!!photoToDelete}
        message="Are you sure you want to delete this photo?"
        onCancel={() => setPhotoToDelete(null)}
        onConfirm={() => {
          handleDelete(photoToDelete);
          setPhotoToDelete(null);
        }}
      />
    </>
  );
};

export default PhotoGallery;
